import dayjs from "dayjs";
import { Dispatch, SetStateAction } from "react";
import { ErrorType } from "../../types/common-type";

type ValidateFormParams = {
  formData: any;
  setErrors: Dispatch<SetStateAction<ErrorType | null>>;
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const mobileRegex = /^[6-9]\d{9}$/;

// PAN format: ABCDE1234F
const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

// UAN format: exactly 12 digits
const uanRegex = /^\d{12}$/;

export const validateForm = ({
  formData,
  setErrors,
}: ValidateFormParams): boolean => {
  const newErrors: Record<string, string> = {};

  if (!formData.first_name?.trim()) {
    newErrors.first_name = "First Name is required";
  }

  if (!formData.last_name?.trim()) {
    newErrors.last_name = "Last Name is required";
  }

  if (!formData.applicant_email?.trim()) {
    newErrors.applicant_email = "Applicant Email is required";
  } else if (!emailRegex.test(formData.applicant_email)) {
    newErrors.applicant_email = "Invalid email format";
  }

  if (!formData.applicant_mobile?.trim()) {
    newErrors.applicant_mobile = "Applicant Mobile Number is required";
  } else if (!mobileRegex.test(formData.applicant_mobile)) {
    newErrors.applicant_mobile =
      "Invalid mobile number (10 digits, starting with 6-9)";
  }

  if (!formData.gender?.trim()) {
    newErrors.gender = "Gender is required";
  }

  if (!formData.dob) {
    newErrors.dob = "Date of Birth is required";
  } else {
    const dob = dayjs(formData.dob, "YYYY-MM-DD", true);

    if (!dob.isValid()) {
      newErrors.dob = "Invalid date of birth";
    } else {
      const today = dayjs();
      const eighteenYearAgo = today.subtract(18, "year");

      if (dob.isAfter(eighteenYearAgo)) {
        newErrors.dob = "Age must be at least 18";
      }
    }
  }

  if (!formData.parent_name?.trim()) {
    newErrors.parent_name = "Father Name is required";
  }

  if (!formData.aadharNumber?.trim()) {
    newErrors.aadharNumber = "Aadhar Card Number is required";
  } else if (!uanRegex.test(formData.aadharNumber.trim())) {
    newErrors.aadharNumber = "Aadhar Number must be exactly 12 digits";
  }

  const panNumber = formData.pan_no?.trim().toUpperCase();

  if (!panNumber) {
    newErrors.pan_no = "PAN No. is required";
  } else if (!panRegex.test(panNumber)) {
    newErrors.pan_no = "Invalid PAN number (Example: ABCDE1234F)";
  }

  if (!formData.address1?.trim()) {
    newErrors.address1 = "Aadhar Address is required";
  }
  if (!formData.address1?.trim()) {
    newErrors.aadhar_pincode = "Aadhar Address Pincode is required";
  }
  if (!formData.hrmsId?.trim()) {
    newErrors.hrmsId = "Candidate ID is required";
  }

  if (!formData.joiningDate) {
    newErrors.joiningDate = "Hire Date is required";
  }
  if (!formData.spocName) {
    newErrors.spocName = "Spoc name is required";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};

// import dayjs from "dayjs";
// import { Dispatch, SetStateAction } from "react";
// import { ErrorType } from "../../types/common-type";

// type ValidateFormParams = {
//   formData: any;
//   setErrors: Dispatch<SetStateAction<ErrorType | null>>;
// };

// const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// const mobileRegex = /^[6-9]\d{9}$/;

// export const validateForm = ({
//   formData,
//   setErrors,
// }: ValidateFormParams): boolean => {
//   const newErrors: Record<string, string> = {};

//   if (!formData.first_name?.trim())
//     newErrors.first_name = "First Name is required";

//   if (!formData.applicant_email?.trim()) {
//     newErrors.applicant_email = "Applicant Email is required";
//   } else if (!emailRegex.test(formData.applicant_email)) {
//     newErrors.applicant_email = "Invalid email format";
//   }

//   if (!formData.applicant_mobile?.trim()) {
//     newErrors.applicant_mobile = "Applicant Mobile Number is required";
//   } else if (!mobileRegex.test(formData.applicant_mobile)) {
//     newErrors.applicant_mobile =
//       "Invalid mobile number (10 digits, starting with 6-9)";
//   }
//   if (!formData.joining_date)
//     newErrors.joining_date = "Joining Date is required";

//   if (!formData.dob) newErrors.dob = "Date of Birth is required";
//   if (formData.dob) {
//     const dob = dayjs(formData.dob, "YYYY-MM-DD", true);

//     if (!dob.isValid()) {
//       newErrors.dob = "Invalid date of birth";
//     } else {
//       const today = dayjs();
//       const age = today.diff(dob, "year");
//       const eighteenYearAgo = today.subtract(18, "year");

//       if (dob.isAfter(eighteenYearAgo)) {
//         newErrors.dob = "Age must be atleast 18";
//       }
//     }
//   }
//   if (!formData.gender) newErrors.gender = "Gender is required";
//   if (!formData.employee_code?.trim())
//     newErrors.employee_code = "Employee ID/Code is required";

//   if (!formData.recruiter_name?.trim())
//     newErrors.recruiter_name = "Recruiter Name is required";

//   if (!formData.recruiter_email?.trim()) {
//     newErrors.recruiter_email = "Recruiter Email is required";
//   } else if (!emailRegex.test(formData.recruiter_email)) {
//     newErrors.recruiter_email = "Invalid email format";
//   }

//   if (!formData.recruiter_mobile?.trim()) {
//     newErrors.recruiter_mobile = "Recruiter Mobile Number is required";
//   } else if (!mobileRegex.test(formData.recruiter_mobile)) {
//     newErrors.recruiter_mobile =
//       "Invalid mobile number (10 digits, starting with 6-9)";
//   }

//   if (!formData.parent_name?.trim())
//     newErrors.parent_name = "Father/Mother Name is required";

//   setErrors(newErrors);
//   return Object.keys(newErrors).length === 0;
// };
